// extracted by mini-css-extract-plugin
module.exports = {"tag":"DashboardTag_tag__1Hb8t"};